import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSessionValidity } from "../Rest_api/RestApi";
import Loading from "./Loading";

interface SessionGuardProps {
  children: React.ReactNode;
}

export const SessionGuard: React.FC<SessionGuardProps> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Skip check if already on login page
    if (location.pathname.includes('/login')) {
      setIsChecking(false);
      return;
    }

    getSessionValidity()
      .then((res) => {
        // Handle invalid session
        if (res.status === false) {
          localStorage.clear();
          navigate('/login', { replace: true });
          setIsChecking(false);
          return;
        }

        // Handle session type routing
        const sessionType = res.session_type;
        const isOnDerivative = location.pathname.includes('/derivative');
        const isOnDashboard = location.pathname.includes('/dashboard');

        if (sessionType === "derivative") {
          if (!isOnDerivative) {
            navigate('/derivative', { replace: true });
          }
        } else if (sessionType === "dashboard") {
          if (isOnDerivative) {
            navigate('/dashboard', { replace: true });
          }
        }

        setIsChecking(false);
      })
      .catch((error) => {
        console.error('Session validation error:', error);
        // On error, redirect to login for safety
        localStorage.clear();
        navigate('/login', { replace: true });
        setIsChecking(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount

  // Show loading screen while checking session
  if (isChecking) {
    return <Loading />;
  }

  // Render children once session is validated
  return <>{children}</>;
};

